import React from 'react';
import { useQuery } from 'react-query';
import { GetCacheKey } from '../../services/common/utils';
import Loadingcomponent from '../../components/loader/loadingcomponent';
import ErrorMessage from '../../components/messaging/errormessage';
import { useSelector } from 'react-redux';
import { Banner } from '../loader/skeletons';
import { getImgSrc } from '../../services/common/CommonUtils';

const SpecialDealsBanner = ({ psmItem }) => {
  const {
    appData: { themeColor },
  } = useSelector((state) => state);

  const {
    data: { data } = {},
    isLoading,
    error,
    isFetching,
    isError,
    isLoadingError,
  } = useQuery(
    [
      GetCacheKey(psmItem?.uniqueid),
      psmItem?.method,
      JSON.parse(psmItem?.sourceid),
      {},
    ],
    {
      retry: false,
      retryOnMount: false,
      cacheTime: 300000,
      staleTime: 300000,
    }
  );

  if (isLoading || isFetching) {
    // return <Loadingcomponent message={'Loading'} />;
    return <Banner height="178px" />
  }

  if (error || isError || isLoadingError) {
    return <ErrorMessage message={'Invalid'} />;
  }

  return (
    <div className="sub_banner_comp" style={{backgroundColor: themeColor}}>
      <div className="sub_banner_comp_container">
        <div className="sub_banner_text">
          <h3>{data?.response[0]?.banners[0]?.title}</h3>
        </div>
        <div className="sub_banner_img">
          <img
            // src={
            //   data?.response[0]?.banners[0]?.path ||
            //   process.env.PUBLIC_URL + '/assets/images/Banners_Bundles@2x.png'
            // }
            src={getImgSrc(data?.response[0]?.banners[0]?.path, true)}
            alt=""
            title=""
          />
        </div>
      </div>
    </div>
  );
};

export default SpecialDealsBanner;
